import { axiosBaseQuery } from '../utils/rtk-query';
import { createApi } from '@reduxjs/toolkit/query/react';
const Config = require('Config');

interface PricingTier {
  monthly: number;
  yearly?: number;
}

export interface BinLookupResponse {
  country?: string;
  'country-code'?: string;
  'card-brand'?: string;
  'ip-city'?: string;
  'ip-blocklists'?: string[];
  'ip-country-code3'?: string;
  'is-commercial'?: boolean;
  'ip-country'?: string;
  'bin-number'?: string;
  issuer?: string;
  'issuer-website'?: string;
  'ip-region'?: string;
  valid?: boolean;
  'card-type'?: string;
  'is-prepaid'?: boolean;
  'ip-blocklisted'?: boolean;
  'card-category'?: string;
  'issuer-phone'?: string;
  'currency-code'?: string;
  'ip-matches-bin'?: boolean;
  'country-code3'?: string;
  'ip-country-code'?: string;
}
export interface BinLookup {
  cardNumber: string;
}
export interface PTSubscriptionPricing {
  premium: PricingTier;
  enterprise: PricingTier;
}
export type CreateSubscriptionResponse = {
  subscriptionId: string;
  profile: {
    customerProfileId: string;
    customerPaymentProfileId: string;
    customerAddressId: string;
  };
};
export interface CreatePTSubscriptionPayload {
  cardData: string;
  cardPaymentType?: string;
  neutrinoData?: BinLookupResponse;
  subscriptionName: 'PT Premium' | 'PT Enterprise';
  paymentTerm: 'monthly' | 'yearly';
  addressInfo: {
    firstName: string;
    lastName: string;
    address: string;
    state: string;
    zip: string;
  };
}

interface ContactUsPayload {
  firstName: string;
  lastName: string;
  companyName: string;
  email: string;
  phoneNumber: string;
}

interface PaymentInterval {
  length: number;
  unit: string;
}

interface PaymentSchedule {
  interval: PaymentInterval;
  startDate: string;
  totalOccurrences: number;
  trialOccurrences: number;
}

interface CreditCard {
  cardNumber: string;
  expirationDate: string;
}

interface Payment {
  creditCard: CreditCard;
}

interface BillTo {
  firstName: string;
  lastName: string;
  address: string;
  state: string;
  zip: string;
}

interface PaymentProfile {
  customerPaymentProfileId: string;
  payment: Payment;
  customerType: string;
  billTo: BillTo;
}

interface CustomerProfile {
  paymentProfile: PaymentProfile;
  customerProfileId: string;
  merchantCustomerId: string;
  email: string;
}

interface Subscription {
  name: string;
  paymentSchedule: PaymentSchedule;
  amount: number;
  trialAmount: number;
  status: string;
  profile: CustomerProfile;
}

interface PTSubscriptionResponse {
  subscription: Subscription;
}

const paymentServiceApi = createApi({
  reducerPath: 'paymentServiceApi',
  baseQuery: axiosBaseQuery({ baseUrl: Config.stcPaymentServiceUrl }),
  endpoints: (builder) => ({
    getPtSubscriptionPricing: builder.query<PTSubscriptionPricing, undefined>({
      query: () => ({
        url: `/pt/subscription/pricing`,
        method: 'GET',
      }),
    }),
    getPtSubscription: builder.query<PTSubscriptionResponse, undefined>({
      query: () => ({
        url: `/pt/subscription`,
        method: 'GET',
      }),
    }),
    sendContactUsForm: builder.mutation<any, ContactUsPayload>({
      query: (payload) => ({
        url: `pt/subscription/enterprise/contact`,
        method: 'POST',
        data: payload,
      }),
    }),
    creatSubscription: builder.mutation<CreateSubscriptionResponse, CreatePTSubscriptionPayload>({
      query: (data) => ({
        url: '/pt/subscription',
        method: 'POST',
        data,
      }),
    }),
    binLookup: builder.mutation<BinLookupResponse, BinLookup>({
      query: (data) => ({
        url: '/bin-lookup',
        method: 'POST',
        data,
      }),
    }),
  }),
});

export const {
  useGetPtSubscriptionPricingQuery,
  useGetPtSubscriptionQuery,
  useBinLookupMutation,
  useCreatSubscriptionMutation,
  useSendContactUsFormMutation,
} = paymentServiceApi;

export default paymentServiceApi;
